export const Home = () => {

     return (
          <div className="page">
               <h2>Welkom op de UNC INC stageopdracht website!</h2>
               <p>Deze website is gemaakt met React, 
                    en de bedoeling is om te kunnen inloggen met de mee gegeven inlog gegevens, 
                    zoals het wachtwoord. Als je inlogt op de website met de verkeerde gegevens hoor je een foutmelding te krijgen. 
                    Als je bent ingelogd krijg je toegang tot een /dashboard. 
                    En als je niet bent ingelogd moet je geen toegang kunnen krijgen tot de /dashboard pagina.</p>
          </div>
     )
}